import PropTypes from 'prop-types';
import FJVirtualizedMixView from '../../../../common/components/FJVirtualizedMixView/FJVirtualizedMixView';
import { useRef } from 'react';
import FJCommunityWorkItemContainer from '../FJCommunityWorkItem/FJCommunityWorkItemContainer';
import { useState, useEffect } from 'react';
import FJUtil from '../../../../util/FJUtil';
import { COMMUNITY_WORKS_TYPE, SKELETON_SCREEN_LIST } from '../../../../config/dataConfig/FJCommunityData';
import FJResourceItemLoading from '../../../../common/components/FJResourceItemLoading/FJResourceItemLoading';
import FJLoading from '../../../../common/components/FJLoading/FJLoading';
import styles from './FJCommunityMixViewList.module.less';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJDropDownManager from '../../../../common/js/FJDropDownManager';
import FJTemplateWorkItemContainer from '../FJTemplateWorkItem/FJTemplateWorkItemContainer';
const IMAGE_SPACE = 6;
const MIN_IMAGE_WIDTH = 260;
const MAX_IMAGE_WIDTH = 320;
const MIN_IMAGE_ROW_NUM = 3;
const TOTAL_SCROLL_THRESHOLD = 1200;
const EXPANSION_TOP = 500;
const FJCommunityMixViewList = props => {
    const {
        list,
        getMoreData,
        renderAheadChildren,
        style,
        className,
        initLoading,
        getMoreLoading,
        hasMore,
        curCategory,
        active,
    } = props;
    const contentRef = useRef(null);
    const [imgWidth, setImgWidth] = useState(MAX_IMAGE_WIDTH);
    const [imgRowNum, setImgRowNum] = useState(3);
    useEffect(() => {
        const _updateUI = FJUtil.debounce(() => {
            if (contentRef.current) {
                const maxWidth = contentRef.current._view.offsetWidth;
                if (!maxWidth) return;
                const rowNum = Math.max(Math.ceil(maxWidth / (IMAGE_SPACE + MAX_IMAGE_WIDTH)), MIN_IMAGE_ROW_NUM);
                const imgW = Math.floor(
                    Math.max(maxWidth / rowNum - IMAGE_SPACE, MIN_IMAGE_WIDTH) + IMAGE_SPACE / rowNum,
                );
                setImgRowNum(rowNum);
                setImgWidth(imgW);
                setTimeout(() => {
                    contentRef.current?.init && contentRef.current.init();
                }, 38);
            }
        }, 38);
        _updateUI();
        window.addEventListener('resize', _updateUI);
        return () => {
            window.removeEventListener('resize', _updateUI);
        };
    }, [list]);
    useEffect(() => {
        if (curCategory) {
            contentRef.current?.scrollTop && contentRef.current.scrollTop(0);
        }
    }, [curCategory]);
    const onScrollStart = () => {
        FJDropDownManager.hideAll();
    };
    const _getSizeList = list => {
        if (!list || list.length === 0) return [];
        let items = [];
        for (let i = 0; i < list.length; i++) {
            let data = list[i];
            let radio = 1;
            if (data.width) {
                radio = parseFloat(data.width / data.height);
            } else if (data.ratio) {
                radio = data.ratio;
            }

            let height = imgWidth / radio;
            items.push({ width: imgWidth, height: height });
        }
        return items;
    };
    const _renderItem = (itemRect, item, idx) => {
        const __renderContent = () => {
            switch (item?.communityType) {
                case COMMUNITY_WORKS_TYPE.TEMPLATE:
                    return <FJTemplateWorkItemContainer item={item} active={active} />;
                case COMMUNITY_WORKS_TYPE.ADVERTISING:
                    // return <FJAdvertisingWorkItemContainer item={item} />;
                    return null;
                case COMMUNITY_WORKS_TYPE.WORKS:
                    return <FJCommunityWorkItemContainer item={item} active={active} />;
                default:
                    return <FJCommunityWorkItemContainer item={item} active={active} />;
            }
        };
        return (
            <div
                key={(curCategory || '') + item?.workType + item?.communityType + item?.id + idx}
                style={{
                    position: 'absolute',
                    left: itemRect.left,
                    top: itemRect.top,
                    width: itemRect.width,
                    height: itemRect.height,
                }}
            >
                {__renderContent()}
            </div>
        );
    };
    const _renderLoadingPanel = () => {
        if (!initLoading) return null;
        return (
            <FJVirtualizedMixView
                className={className}
                style={{ ...style }}
                list={SKELETON_SCREEN_LIST}
                row={imgRowNum}
                childrenSizeList={_getSizeList(SKELETON_SCREEN_LIST)}
                rowSpace={IMAGE_SPACE}
                verticalSpace={IMAGE_SPACE}
                renderItem={(itemRect, item, idx) => {
                    return (
                        <FJResourceItemLoading
                            key={item?.id + idx}
                            style={{
                                position: 'absolute',
                                left: itemRect.left,
                                top: itemRect.top,
                                width: itemRect.width,
                                height: itemRect.height,
                            }}
                        />
                    );
                }}
                ref={contentRef}
                aheadChildren={renderAheadChildren && renderAheadChildren()}
                getData={getMoreData}
                onScrollStart={onScrollStart}
            />
        );
    };
    return initLoading ? (
        _renderLoadingPanel()
    ) : (
        <FJVirtualizedMixView
            className={className}
            style={{ ...style }}
            list={list || []}
            row={imgRowNum}
            childrenSizeList={_getSizeList(list)}
            rowSpace={IMAGE_SPACE}
            verticalSpace={IMAGE_SPACE}
            renderItem={_renderItem}
            ref={contentRef}
            aheadChildren={renderAheadChildren && renderAheadChildren()}
            getData={getMoreData}
            onScrollStart={onScrollStart}
            totalScrollThreshold={TOTAL_SCROLL_THRESHOLD}
            expansionTop={EXPANSION_TOP}
        >
            {getMoreLoading && (
                <div className={styles.loading_box}>
                    <FJLoading strokeColor='#a8acbc' style={{ width: 20, height: 20 }} />
                </div>
            )}
            {!hasMore && !getMoreLoading && (
                <div className={styles.end_box}>
                    <div className={styles.end_text}>{FJLocalStore._('scroll-end-tip')}</div>
                </div>
            )}
        </FJVirtualizedMixView>
    );
};

FJCommunityMixViewList.propTypes = {
    list: PropTypes.array,
    renderAheadChildren: PropTypes.func,
    getMoreData: PropTypes.func,
    row: PropTypes.number,
    itemRenderWidth: PropTypes.number,
    style: PropTypes.object,
    className: PropTypes.string,
    initLoading: PropTypes.bool,
    getMoreLoading: PropTypes.bool,
    hasMore: PropTypes.bool,
    curCategory: PropTypes.string,
    active: PropTypes.bool,
};

export default FJCommunityMixViewList;
